module.exports = __webpack_public_path__ + "img/fi-rr-circle.0766ffe1.svg";